export default __webpack_public_path__ + "static/Behemoth_Tek_Gateway-d6d00ae32d157936d79ab8e996c3b2b4.png";